import { SystemsQueryRequestConfig } from 'utils/systems-query-request-types';

const SYSTEMS_QUERY_PATHS = new Set([
  'valid-systems',
  'existing-equipment/compatible-combinations'
]);

const requestPath = (url: string): string =>
  url.replace(/^\/+/, '').split('?')[0];

export function isSystemsQueryRequest({
  method,
  url
}: SystemsQueryRequestConfig): boolean {
  if (!method || !url) return false;
  return (
    method.toLowerCase() === 'post' && SYSTEMS_QUERY_PATHS.has(requestPath(url))
  );
}
